import type { IListResponse, ISubject } from '@dakedake/types'
import { request } from '@umijs/max'

/** 获取剧集详情 GET /backend/subject/:id */
export async function subjectDetail(options?: Record<string, any>) {
  return request<{
    data: ISubject
  }>('/backend/subject/:id', {
    method: 'GET',
    ...options
  })
}

/** 获取是否有重名 GET /backend/subject/getName */
export async function subjectName(
  params: {
    name: string
    id?: number
  },
  options?: Record<string, any>
) {
  return request<{
    data: ISubject
  }>('/backend/subject/getName', {
    method: 'GET',
    params,
    ...options
  })
}

/** 获取剧集列表 GET /backend/subject/list */
export async function subjectList(
  params: {
    // query
    /** 当前的页码 */
    current?: number
    /** 页面的容量 */
    pageSize?: number
    /** 排序字段 */
    orderBy?: string
    /** 排序方式 */
    order?: string
    /** 筛选条件 */
    filter?: string
  },
  options?: Record<string, any>
) {
  return request<IListResponse<ISubject>>('/backend/subject/list', {
    method: 'GET',
    params,
    ...options
  })
}

/** 添加/编辑剧集 POST /api/subject/add */
export async function subjectAdd(body: ISubject, options?: Record<string, any>) {
  return request<{ data: ISubject, success: boolean, message: string }>('/backend/subject/add', {
    method: 'POST',
    data: body,
    ...options
  })
}

/** 更新剧集剧照 POST /api/subject/editCover */
export async function subjectEditCover(body: { id?: number, cover?: number }, options?: Record<string, any>) {
  return request<{ data: ISubject, success: boolean, message: string }>('/backend/subject/editCover', {
    method: 'POST',
    data: body,
    ...options
  })
}

/** 获取bangumi GET /backend/subject/bangumi */
export async function subjectBangumi(
  params: {
    // query
    /** 当前的页码 */
    current?: number
    /** 页面的容量 */
    pageSize?: number
  },
  options?: Record<string, any>
) {
  return request<IListResponse<any>>('/backend/subject/bangumi', {
    method: 'GET',
    params: {
      ...params
    },
    ...options
  })
}

/** 删除剧集 DELETE /api/subject/delete */
export async function subjectDelete(options?: Record<string, any>) {
  return request<Record<string, any>>('/backend/subject/delete', {
    method: 'DELETE',
    ...options
  })
}

/** 清除 bangumi 缓存 GET /backend/subject/clearBangumiCache */
export async function subjectClearBangumiCache(options?: Record<string, any>) {
  return request<{ success: boolean, message: string }>('/backend/subject/clearBangumiCache', {
    method: 'GET',
    ...options
  })
}
